import client, { simpleClient } from './apollo-client'

export const clearStore = () => {
    client.clearStore();
    simpleClient.clearStore();
    // work around for issue with clear store.
    // user info was not clearing up.
    client.cache.reset();
    simpleClient.cache.reset();
}